import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { IonicPageModule } from "ionic-angular";
import { NavigationModule } from "navigation/navigation.module";
import { ForgotPassword } from "./forgot-password";
@NgModule({
  declarations: [ForgotPassword],
  imports: [
    IonicPageModule.forChild(ForgotPassword),
    TranslateModule.forChild(),
    NavigationModule,
    CommonComponentsModule,
  ],
  entryComponents: [ForgotPassword],
  exports: [ForgotPassword],
})
export class ForgotPasswordCognitoModule {}



// WEBPACK FOOTER //
// ./src/pages/common/cognito/forgot-password-cognito/forgot-password.module.ts